import { UserConst } from '@axiom/const';
import { Api } from '@axiom/ui';
import { UserEntity } from '@axiom/domain';
import type { Group, User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class LegacyUserApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readUsers(query: { roles?: string[] } = {}) {
    return super.read<{ data: User[] }>({
      endpoint: '/users',
      method: 'GET',
      encodeQuery: false,
      query: {
        roles: [
          UserConst.UserRoles.EnvoyAdmin,
          UserConst.UserRoles.EnvoyUser,
          UserConst.UserRoles.EnvoySales,
        ],
        ...query,
      },
      schema: { data: [UserEntity] },
    });
  }

  readUserGroups({ userId }: { userId: User['id'] }) {
    return super.read<{ data: Group[] }>({
      endpoint: `/users/${userId}/groups`,
      method: 'GET',
    });
  }
}

export const LegacyUserApi = new LegacyUserApiClass();

// Promise-returning compat shims for legacy non-React consumers (redux sagas,
// GenericStore, typeaheads). They wrap the Api-class reads via toPromise()
// rather than the deprecated LegacyApiHelper.
export const getUsers = async (query: { roles?: string[] } = {}) =>
  LegacyUserApi.readUsers(query).toPromise();

export const getUserGroups = async (user: User) =>
  LegacyUserApi.readUserGroups({ userId: user.id }).toPromise();
